import {
  ArrowBackOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import SearchIcon from "@mui/icons-material/Search";
import VerticalAlignBottomOutlinedIcon from '@mui/icons-material/VerticalAlignBottomOutlined';
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exportToExcelJS } from "../../../../Helpers/ExcelJsHelper";
import useConfirm from "../../../../hooks/useConfirm";
import { useQuery } from "../../../../hooks/useQuery";
import useToast from "../../../../hooks/useToast";
import { AssociationMembreCVService } from "../../../../service/admin_service/AssociationMembreCVService";

const AssociationMembersCVList = ({
  selection = false,
  id_type,
  handleSelectedCV,
}) => {
  const [membres, setMembres] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const navigate = useNavigate();
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const query = useQuery();
  const uuid = query.get("ref");

  const handleFetchMembre = () => {
    setDataLoading(true);
    AssociationMembreCVService.listCVMembre({ association_id: uuid })
      .then((res) => {
        if (res && res.data) {
          setMembres(res.data);
          setFilteredRows(res.data);
        } else {
          setMembres([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(membres);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      membres.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot)
          )
        )
      )
    );
  };

  const table_colonne = [
    {
      field: "full_name",
      headerName: "Nom et prénoms",
      minWidth: 250,
    },
    {
      field: "adresse",
      headerName: "Adresse",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "annee_naissance",
      headerName: "Année de naissance",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "telephone1",
      headerName: "Téléphone",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "adresse_email",
      headerName: "Adresse email",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "nif",
      headerName: "N° NIF",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "stat",
      headerName: "N° STAT",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "role_responsable",
      headerName: "Fonction",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "etudes",
      headerName: "Etudes",
      minWidth: 250,
      flex: 2,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = String(params.value).substring(2).split("\n -");
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "experiences",
      headerName: "Experiences",
      minWidth: 250,
      flex: 2,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = params.value.substring(2).split("\n -");
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "formation",
      headerName: "Formations",
      minWidth: 250,
      flex: 2,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = params.value.substring(2).split("\n -");
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "autre_competence",
      headerName: "Autres competences",
      minWidth: 250,
      flex: 2,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = params.value.substring(2).split("\n -");
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
  ];

  const handleDownloadExcel = () => {
    exportToExcelJS(membres, table_colonne, "Liste des CV membres de l'association");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    handleFetchMembre();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Liste des CV membres"
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <IconButton color="primary" onClick={handleGoBack} title="Retour">
                  <ArrowBackOutlined />
                </IconButton>
              }
              action={
                <Grid container spacing={1}>
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      title="Actualiser"
                      onClick={handleFetchMembre}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      title="Exporter en excel"
                      onClick={handleDownloadExcel}
                    >
                      <VerticalAlignBottomOutlinedIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                  "& .MuiDataGrid-cell": {
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    alignContent: "center",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                  },
                }}
                getRowHeight={() => "auto"}
                columns={table_colonne}
                rows={filteredRows}
                getRowId={(row) => row.id_ext_user}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AssociationMembersCVList;
